<template>

	<div class="gray-bg" style="min-height: 100vh">

		<div class="middle-box text-center loginscreen animated fadeInDown">
			<div>

				<div>
          <a target="_blank" href="https://www.snatchpark.com/parkbills/">
            <img src="/static/image/parkbills.png">
          </a>
					<img src="/static/image/park_bills_text_black.png">
				</div>

				<h3>Welcome to ParkBills</h3>

				<form class="m-t" role="form" method="post" action="">
					
					<div class="form-group">
						<input v-bind="success ? {disabled: 1} : {}" v-model="username" type="email" class="form-control" placeholder="Email" required="">
					</div>
					
					<div class="form-group">
						<input v-bind="success ? {disabled: 1} : {}" v-model="password" type="password" class="form-control" placeholder="Password" required="">
					</div>

          <h3 class="smaller lighter grey" v-show="isLoading"><i class="fa fa-spin fa-spinner"></i></h3>
          <label class="text-info form-control-feedback" >{{ success }}</label>
          <label class="error form-control-feedback" >{{ error }}</label>
					
					<button type="submit" class="btn btn-secondary block full-width m-b btn-snatch" @click.prevent="handleSubmit">
						Login
					</button>

					<a v-bind:href="helper.WEB_URL + '/forgotPassword'"><small>Forgot password?</small></a>
          <a class="btn btn-sm btn-white btn-block m-t" v-bind:href="helper.WEB_URL + '/register'">Register</a>

				</form>
				
				<p class="m-t">
					<small><strong>Copyright</strong> PARKAIDE &copy; 2018</small>
				</p>
				
			</div>
		</div>
    
  </div>

</template>

<script>
import helper from "@/components/Utility/Helper"

export default {
  name: "PageLogin",
  data(){
      return {
          helper: helper,
          username : "",
          password : "",
          error : "",
          success : "",
          isLoading: false,
      }
  },
  mounted() {
    if(window.location.href.includes('localhost')) {
      document.title = 'Localhost';
    } else if(window.location.href.includes('parkbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    } else if(window.location.href.includes('devpbills.parkaidemobile.com')) {
      document.title = 'ParkBills Dev';
    }
  },
  methods : {
    async handleSubmit(e){
      if(this.isLoading) {
        return;
      }

      // e.preventDefault();
      if (!this.username || this.username.length === 0 || !this.password || this.password.length === 0) {
        this.error = 'Please fill in required info before proceed.';
        return;
      }

      this.isLoading = true;
      this.error = '';

      let user =  await this.$http
        .post(
          helper.API_URL + '/api2/auth2/web/login', 
          {
            email: this.username,
            password: this.password
          }
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          let user = {};
          user.username = this.username;
          user.userID = response.data.userID;
          user.jwt = response.data.token;
          return user;
          // user.jwt = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MywiaWF0IjoxNTQwNTI1MTAxLCJleHAiOjE1NDA2MTE1MDF9.uGLHTtPi8qZSia4gTLNmIvh1pZOWtAPV9V9aorx_vgQ';
        })
        .catch((error) => {
          this.error = 'Problem logging in. ' + this.parseLoginError(error);
        });

      if(!user) {
        this.isLoading = false;
        this.error = this.error || 'Problem logging in.';
        return;
      } else {
        this.error = '';
        this.success = 'Successfully logged in. Redirecting...'
      }

      helper.setUser(this, user);
      this.isLoading = false;
    },
    parseLoginError(error) {
      if(error) {
        if(error.response) {
          if(error.response.data) {
            if(error.response.data.message) {
              return error.response.data.message;
            }

            if(typeof a_string === 'string') {
              return error.response.data;
            }
          }

          if(typeof a_string === 'string') {
            return error.response;
          }
        }
      }

      return 'Please try again.'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Page/User/PageLogin.vue